export default {"src":"/_next/static/media/close.7b9fe212.svg","height":25,"width":25};